import { appConfig } from '@/shared/config/app-config';

export type PasswordResetTokenStatus = { valid: boolean };

export async function getPasswordResetTokenStatus(
    token: string,
): Promise<PasswordResetTokenStatus> {
    try {
        const response = await fetch(`${appConfig.apiUrl}/auth/reset-password/status`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        });
        if (!response.ok) return { valid: false };
        const data = (await response.json()) as { valid?: boolean };
        return { valid: data.valid === true };
    } catch {
        return { valid: false };
    }
}

export type ConfirmPasswordResetResult =
    | { ok: true }
    | { ok: false; code: 'LINK_INVALID' | 'WEAK_PASSWORD' | 'UNKNOWN' };

export async function confirmPasswordReset(input: {
    token: string;
    password: string;
}): Promise<ConfirmPasswordResetResult> {
    try {
        const response = await fetch(`${appConfig.apiUrl}/auth/reset-password`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });

        if (response.ok) return { ok: true };
        if (response.status === 410) return { ok: false, code: 'LINK_INVALID' };
        if (response.status === 422) return { ok: false, code: 'WEAK_PASSWORD' };
        return { ok: false, code: 'UNKNOWN' };
    } catch {
        return { ok: false, code: 'UNKNOWN' };
    }
}
